<template>
	<div  style="width: 100%;">
		<PageHeader @back="goback" :content="'挂机状态'" />
		<div class="interviewerBox">
			<!-- <div><el-button @click="goSetOverallStatus">设置</el-button></div> -->
			 
			<div class="radioBtn">
				<el-button size="medium"  type="primary" @click="allAllot">全部分配</el-button>
				<el-button size="medium"  type="primary" @click="alldelAllot">全部取消</el-button>
			</div>
			<div class="topTable">
				<el-table border :data="noQueryInterviewstateData" style="width: 100%">
					<el-table-column align="center" fixed prop="isState" label="访问状态"></el-table-column>
					<el-table-column align="center" prop="isDesc" label="状态描述"></el-table-column>
					<el-table-column align="center" prop="ssId" label="样本状态">
						<template slot-scope="scope">
							<span v-if="scope.row.ssId == 1">初始</span>
							<span v-else-if="scope.row.ssId == 2">读取</span>
							<span v-else-if="scope.row.ssId == 3">中断</span>
							<span v-else-if="scope.row.ssId == 4">甄别</span>
							<span v-else-if="scope.row.ssId == 5">条件不符</span>
							<span v-else-if="scope.row.ssId == 6">完成</span>
							<span v-else-if="scope.row.ssId == 7">配额已满</span>
							<span v-else-if="scope.row.ssId == 8">无效样本</span>
							<span v-else-if="scope.row.ssId == 9">预拨取号</span>
							<span v-else-if="scope.row.ssId == 10">审核作废</span>
							<span v-else-if="scope.row.ssId == 11">稍后</span>
							<span v-else-if="scope.row.ssId == 12">约访</span>
							<span v-else-if="scope.row.ssId == 0">无</span>
							<span v-else>其他</span>
						</template>
					</el-table-column>
					<el-table-column align="center" fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-link icon="el-icon-circle-check" type="primary" :underline="false" @click="allotRow(scope)">分配</el-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="noPagination.pageNo"
						:page-sizes="[10, 50, 100, 200, 300, 400]"
						:page-size="noPagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="noPagination.total"
					></el-pagination>
				</div>
			</div>

			<div class="botTable">
				<el-table border :data="queryInterviewstateData" style="width: 100%">
					<el-table-column align="center" fixed prop="isState" label="访问状态"></el-table-column>
					<el-table-column align="center" prop="isDesc" label="状态描述"></el-table-column>
					<el-table-column align="center" prop="ssId" label="样本状态">
						<template slot-scope="scope">
							<span v-if="scope.row.ssId == 1">初始</span>
							<span v-else-if="scope.row.ssId == 2">读取</span>
							<span v-else-if="scope.row.ssId == 3">中断</span>
							<span v-else-if="scope.row.ssId == 4">甄别</span>
							<span v-else-if="scope.row.ssId == 5">条件不符</span>
							<span v-else-if="scope.row.ssId == 6">完成</span>
							<span v-else-if="scope.row.ssId == 7">配额已满</span>
							<span v-else-if="scope.row.ssId == 8">无效样本</span>
							<span v-else-if="scope.row.ssId == 9">预拨取号</span>
							<span v-else-if="scope.row.ssId == 10">审核作废</span>
							<span v-else-if="scope.row.ssId == 11">稍后</span>
							<span v-else-if="scope.row.ssId == 12">约访</span>
							<span v-else-if="scope.row.ssId == 0">无</span>
							<span v-else>其他</span>
						</template>
					</el-table-column>
					<el-table-column align="center" fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-popconfirm title="确定删除吗？" @confirm="cancelRow(scope)">
								
								<el-link slot="reference" type="primary" :underline="false">取消</el-link>
							</el-popconfirm>
							<el-link style="margin-left: 10px;" type="primary" :underline="false" @click="editRow(scope)">分配</el-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pagination.pageNo"
						:page-sizes="[10, 50, 100, 200, 300, 400]"
						:page-size="pagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total"
					></el-pagination>
				</div>
			</div>
			<!-- <div class="subBtn"><el-button round type="primary" class="btn">确定</el-button></div> -->
		</div>
		
		<!-- 编辑 -->
		<el-dialog title="编辑" :visible.sync="centerDialogVisible" width="800" :close-on-click-modal="false">
			<span>
				<el-form :model="form">
					<el-form-item label="访问状态" :label-width="formLabelWidth"><el-input disabled v-model="form.isState" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="样本状态" :label-width="formLabelWidth">
						<el-radio v-model="form.ssId" label="0">无</el-radio>
						<el-radio v-model="form.ssId" label="1">放回</el-radio>
						<el-radio v-model="form.ssId" label="8">无效</el-radio>
						<el-radio v-model="form.ssId" label="11">稍后</el-radio>
					</el-form-item>
					<el-form-item label="样本描述" :label-width="formLabelWidth">
						<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.isDesc"></el-input>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" type="primary" @click="addInterviewstate">确 定</el-button>
				<el-button size="medium" @click="centerDialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		PageHeader
	},
	data() {
		return {
			source:'',
			centerDialogVisible:false,
			form: {
				isState: '',
				ssId: '',
				isDesc: ''
			},
			id: '',
			radio: '1',
			// 未分配的样本状态
			noQueryInterviewstateData: [],
			noPagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			// 已分配的样本状态
			queryInterviewstateData: [],
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
				formLabelWidth: '120px',
		};
	},
	created() {
		this.id = this.$route.query.id;
		this.source = this.$route.query.source;
		this.queryInterviewstate();
		this.queryNoInterviewstate();
	},
	methods: {
		alldelAllot(){
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.removeAllInterviewstate}`,
				method: 'POST',
				data: {
					qid: that.id,
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody.records);
						that.queryInterviewstate();
						that.queryNoInterviewstate();
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		allAllot(){
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.addAllInterviewstate}`,
				method: 'POST',
				data: {
					qid: that.id,
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody.records);
						that.queryInterviewstate();
						that.queryNoInterviewstate();
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		addInterviewstate() {
			let that = this;
			let data = that.form;
			let params = {
				that: this,
				url: `${this.$config.service.oneModifyInterviewstate}`,
				method: 'POST',
				data: data,
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.centerDialogVisible = false;
						that.form = {
							isState: '',
							ssId: '',
							isDesc: ''
						};
							that.queryInterviewstate();
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 编辑
		editRow(scope) {
			this.title = '编辑';
			this.form = JSON.parse(JSON.stringify(scope.row));
			delete this.form.isPromissoryInterview;
			delete this.form.createId;
			delete this.form.createTime;
			this.centerDialogVisible = true;
		},
		cancelRow(scope) {
			console.log(scope.row);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.oneRemoveInterviewstate}`,
				method: 'POST',
				data: {
					qid: that.id,
					id: scope.row.id
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody.records);
						that.queryInterviewstate();
						that.queryNoInterviewstate();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		allotRow(scope) {
			console.log(scope.row);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.oneAddInterviewstate}`,
				method: 'POST',
				data: {
					qid: that.id,
					// id: scope.row.id,
					isDesc: scope.row.isDesc,
					isId: scope.row.id,
					isState: scope.row.isState,
					ssId: scope.row.ssId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody.records);
						that.queryInterviewstate();
						that.queryNoInterviewstate();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		queryNoInterviewstate() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.oneQueryNoInterviewstate}?pageNo=${this.noPagination.pageNo}&pageSize=${this.noPagination.pageSize}&qid=${this.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody.records);
						that.noQueryInterviewstateData = res.resultBody.records;
						that.noPagination.total = res.resultBody.total;
					} else {
						that.noQueryInterviewstateData = [];
						that.noPagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		queryInterviewstate() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.oneQueryInterviewstate}?pageNo=${this.pagination.pageNo}&pageSize=${this.pagination.pageSize}&qid=${this.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.queryInterviewstateData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.queryInterviewstateData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		noHandleSizeChange(val) {
			this.noPagination.pageSize = val;
			this.queryNoInterviewstate()
		},
		noHandleCurrentChange(val) {
			this.noPagination.pageNo = val;
			this.queryNoInterviewstate()
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.queryInterviewstate()
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
			this.queryInterviewstate()
		},
		goback() {
			this.$router.go(-1)
		},
	}
};
</script>

<style lang="scss" scoped>
.details_header {
	// max-width: 1200px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;
	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}
	margin-bottom: 20px;
	cursor: pointer;
}
.interviewerBox {
	padding: 0 20px 20px 20px;
	margin: 0px auto;
	.radioBtn {
		text-align: right;
		margin-bottom: 20px;
	}
	.topTable {
		margin-bottom: 20px;
		margin-top: 20px;
		.block {
			text-align: right;
			margin-top: 20px;
		}
	}
	.botTable {
		.block {
			text-align: right;
			margin-top: 20px;
		}
	}
	.subBtn {
		margin-top: 20px;
		text-align: center;
		.btn {
			width: 200px;
			height: 60px;
			font-size: 24px;
		}
	}
}
</style>
